import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getSiteContent } from "@/lib/api";

export default function Footer() {
  const [social, setSocial] = useState([]);
  const [contact, setContact] = useState(null);
  useEffect(() => {
    getSiteContent("social_links").then((v) => setSocial(v?.links || [])).catch(() => {});
    getSiteContent("contact_info").then(setContact).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="bg-navy text-slate-300">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="font-serif text-2xl text-white">Dr. Bhawna Sirohi</div>
            <div className="overline mt-2 text-gold">MBBS, FRCP</div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
              Medical Oncologist · Breast & Gastrointestinal Cancer Specialist · Researcher · Educator · Cancer Advocate.
            </p>
            {contact?.disclaimer && (
              <p className="mt-6 max-w-md text-xs leading-relaxed text-slate-500">{contact.disclaimer}</p>
            )}
          </div>
          <div>
            <div className="overline text-gold">Explore</div>
            <ul className="mt-4 space-y-2 text-sm">
              {[["About", "/about"], ["Research", "/research"], ["Clinical Expertise", "/clinical-expertise"], ["Impact", "/impact"], ["Insights", "/insights"], ["Contact", "/contact"]].map(([l, t]) => (
                <li key={t}><Link to={t} className="text-slate-400 transition-colors hover:text-gold">{l}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="overline text-gold">Connect</div>
            <ul className="mt-4 space-y-2 text-sm">
              {social.map((s) => (
                <li key={s.label}><a href={s.url} target="_blank" rel="noopener noreferrer" className="text-slate-400 transition-colors hover:text-gold">{s.label}</a></li>
              ))}
              {contact?.email && <li><a href={`mailto:${contact.email}`} className="text-slate-400 hover:text-gold">{contact.email}</a></li>}
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 md:flex-row">
          <span>© {new Date().getFullYear()} Dr. Bhawna Sirohi. All rights reserved.</span>
          <div className="flex gap-6">
            <Link to="/collaborate" className="hover:text-gold">Collaborate</Link>
            <Link to="/get-involved" className="hover:text-gold">Get Involved</Link>
            <Link to="/support" className="hover:text-gold">Support NICCI</Link>
            <Link to="/admin/login" className="hover:text-gold">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
